import * as Modal from "../../../src/Components/Modal/Modal.scss";
import { Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { union_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { createElement } from "react";
import * as react from "react";
import { getWrappedMaterialIcon } from "../../ViewUtils.js";
import { classNames } from "../../Utils.js";
import { ofArray } from "../../fable_modules/fable-library.3.7.20/List.js";
import * as react_draggable from "react-draggable";
import { getDefaultProps } from "../Draggable/Draggable.js";


export class ModalSize extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Small", "Medium", "Large", "Unlimited"];
    }
}

export function ModalSize$reflection() {
    return union_type("Components.Modal.ModalSize", [], ModalSize, () => [[], [], [], []]);
}

export function getModalContainer(size, modalContent) {
    const classes = "modal-base__container " + ((size.tag === 1) ? "modal-base__container--medium" : ((size.tag === 2) ? "modal-base__container--large" : ((size.tag === 3) ? "modal-base__container--unlimited" : "modal-base__container--small")));
    return react.createElement("div", {
        className: classes,
    }, modalContent);
}

function modalHeader(header, onCloseClick) {
    let children;
    const children_2 = [(children = [getWrappedMaterialIcon("close")], react.createElement("div", {
        className: "modal-base__close",
        onClick: onCloseClick,
    }, ...children)), header];
    return react.createElement("div", {
        className: "modal-base__header-container",
    }, ...children_2);
}

export function getModalHeader(heading, onCloseClick) {
    return modalHeader(react.createElement("h1", {
        className: "modal-base__heading",
    }, heading), onCloseClick);
}

export function getCustomModalHeader(heading, onCloseClick) {
    return modalHeader(heading, onCloseClick);
}

export function getModalBodyContainer(bodyContent) {
    return react.createElement("div", {
        className: "modal-base__body-container",
    }, bodyContent);
}

export function getModalFooterContainer(footerContent) {
    return react.createElement("div", {
        className: "modal-base__footer-container",
    }, footerContent);
}

export function modal(isOpen, content) {
    let children_3;
    const classes = classNames(ofArray([["modal-base", true], ["show-modal", isOpen]]));
    if (isOpen) {
        const children_5 = [(children_3 = [createElement(react_draggable, {
            axis: getDefaultProps.axis,
            bounds: getDefaultProps.bounds,
            cancel: getDefaultProps.cancel,
            children: react.createElement("div", {
                className: "modal-base__content",
            }, content),
            defaultClassName: getDefaultProps.defaultClassName,
            defaultClassNameDragged: getDefaultProps.defaultClassNameDragged,
            defaultClassNameDragging: getDefaultProps.defaultClassNameDragging,
            defaultPosition: getDefaultProps.defaultPosition,
            disabled: getDefaultProps.disabled,
            grid: getDefaultProps.grid,
            handle: ".modal-base__header-container",
            nodeRef: getDefaultProps.nodeRef,
            offsetParent: getDefaultProps.offsetParent,
            onDrag: getDefaultProps.onDrag,
            onMouseDown: getDefaultProps.onMouseDown,
            onStart: getDefaultProps.onStart,
            onStop: getDefaultProps.onStop,
            position: getDefaultProps.position,
            positionOffset: getDefaultProps.positionOffset,
            scale: getDefaultProps.scale,
        })], react.createElement("div", {
            className: "modal-base__center",
        }, ...children_3))];
        return react.createElement("div", {
            className: classes,
            onClick: (e) => {
                e.stopPropagation();
            },
        }, ...children_5);
    }
    else {
        return react.createElement(react.Fragment, {});
    }
}

